import { render, staticRenderFns } from "./WalletInfo.vue?vue&type=template&id=175d8afa&"
import script from "./WalletInfo.vue?vue&type=script&lang=js&"
export * from "./WalletInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports